"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChartPieOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm1 2.05a11.9 11.9 0 016.74 2.8L17 13.59zm-2 0V15H4.05A12 12 0 0115 4.05zM4.05 17h11.36l5.43 10A11.86 11.86 0 0116 28 12 12 0 014.05 17zm18.55 9l-5.36-9.83 7.91-7.92A12 12 0 0122.6 26z" })));
}
exports.default = SvgChartPieOutline;
//# sourceMappingURL=ChartPieOutline.js.map